// Firebase Cloud Messaging Configuration File. 
// Read more at https://firebase.google.com/docs/cloud-messaging/js/client && https://firebase.google.com/docs/cloud-messaging/js/receive

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import axios from "axios";
import Cookies from "js-cookie";

var firebaseConfig = {
  apiKey: "AIzaSyB2HmwdqRYWGByo7C2KSb-MdhOp3EsAC78",
  authDomain: "tom-fcm.firebaseapp.com",
  projectId: "tom-fcm",
  storageBucket: "tom-fcm.appspot.com",
  messagingSenderId: "187771525672",
  appId: "1:187771525672:web:8edc50562f02d6a290331d",
  measurementId: "G-MH5NGK97XW"
};

initializeApp(firebaseConfig);

const messaging = getMessaging();

export const requestForToken = () => {
  return getToken(messaging, { vapidKey: `BM-cOvy0GzuWw1LpLN7wDaDlOFnv9iv0uXEE7XS85A5ZEsukbUbGeKibuIr3-2NibtPQAhnh0r8Xmru9mB68gKY` })
    .then((currentToken) => {
      if (currentToken) {
        console.log('current token for client:', currentToken);
        Cookies.set("TokenFCM",currentToken, {expires:1})
        // sendToken(currentToken);
        // Perform any other neccessary action with the token
      } else {
        // Show permission request UI
        console.log('No registration token available. Request permission to generate one.');
      }
    })
    .catch((err) => {
      console.log('An error occurred while retrieving token. ', err);
    });
};

// Handle incoming messages. Called when:
// - a message is received while the app has focus
// - the user clicks on an app notification created by a service worker `messaging.onBackgroundMessage` handler.
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

// const sendToken = (token) => {

//   var data = {
//     "vendor_id": localStorage.getItem("Doctor_id"),
//     "token":token
//   };
//   axios
//     .post("admin/insertvendorwebtoken", data)
//     .then((response) => {
//       console.log("update token response", response);
//     })
//     .catch((error) => {
//       console.log(error);
//     });
// } 
